/**
 * Public (unauthenticated) fetch for the in-app announcement feed. Read on app open
 * by every user (guests included); served through the server's SWR `/app-config` cache.
 * See specs/in-app-announcements/spec.md.
 */

import axios from 'axios';
import { buildApiUrl, API_ENDPOINTS } from '../../../constants/api';
import type { Announcement } from '../types/announcements.types';

interface AnnouncementsEnvelope {
  success: boolean;
  data?: { announcements?: Announcement[] };
  error?: string;
}

/**
 * Fetch the eligible announcement feed. Fails soft: any non-success payload yields an
 * empty feed (the modal is a non-critical launch surface — never block or error on it).
 */
export async function fetchAnnouncements(): Promise<Announcement[]> {
  const url = buildApiUrl(API_ENDPOINTS.appConfig.announcements);
  const response = await axios.get<AnnouncementsEnvelope>(url, { timeout: 10000 });
  if (!response.data?.success || !response.data.data?.announcements) return [];
  return response.data.data.announcements;
}
